import React, { Component } from 'react'
import { connect } from 'react-redux'
import PageOverlay from '../Controls/PageOverlay'
import ColorButton from '../Controls/ColorButton'

import CustomerCheckbox from '../CustomerCheckbox'
import IfAdmin from '../IfAdmin'
import { clientValues, regionValues, statusValues } from './constants'
import Dropdown from './Dropdown'
import {
  cancelCopyPoll,
  startSave,
  isOngoing,
  setCustomer,
  removeCustomer,
  getCustomerIds,
  getErrors,
  isSaving,
  clearCustomersId,
  selectAllCustomersId,
} from '../../stores/polls/copyPoll'
import {
  filterCustomers,
  selectFilteredCustomers,
} from '../../stores/customersStore'

class CopyModal extends Component {
  state = {
    valueRegion: regionValues[0].value,
    valueClient: clientValues[0].value,
    valueStatus: statusValues[0].value,
  }

  render() {
    const {
      isOngoing,
      activeFilter,
      setCustomer,
      removeCustomer,
      save,
      isSaving,
      cancel,
      errors,
      customerIds,
      filterCustomers,
      clearCustomersId,
      selectAllCustomersId,
      filteredCustomers,
    } = this.props

    const { valueRegion, valueClient, valueStatus } = this.state

    if (!isOngoing) return null

    const filterSelection = {
      country: valueRegion,
      brand: valueClient,
      status: valueStatus,
    }

    return (
      <PageOverlay>
        <div className="w-100 h-100 bg-white z-999 flex flex-column">
          <div className="bg-op-con-dark white h2 flex flex-none items-center pa2">
            Copy a poll
          </div>
          <IfAdmin>
            <div className="w-100 h3 bg-near-white flex flex-none items-center justify-start ph3">
              <label>Region:</label>
              <Dropdown
                options={regionValues}
                value={this.state.valueRegion}
                onChange={val => this.setState({ valueRegion: val })}
              />
              <span>Client:</span>
              <Dropdown
                options={clientValues}
                value={this.state.valueClient}
                onChange={val => this.setState({ valueClient: val })}
              />
              <span>Status:</span>
              <Dropdown
                options={statusValues}
                value={this.state.valueStatus}
                onChange={val => this.setState({ valueStatus: val })}
              />

              <ColorButton
                className="ml3"
                borderClass="b-op-brand"
                disabled={activeFilter === filterSelection}
                colorClass={
                  activeFilter === filterSelection ? 'op-brand' : 'black'
                }
                onClick={() => {
                  filterCustomers(filterSelection)
                  clearCustomersId()
                }}
              >
                FILTER
              </ColorButton>
            </div>
          </IfAdmin>

          <div className="flex-auto overflow-y-auto ph4 pv3">
            {errors ? (
              <div>
                <pre>{JSON.stringify(errors, null, 2)}</pre>
              </div>
            ) : null}

            <div className="pb3">
              <ColorButton
                borderClass="b-op-brand"
                onClick={() =>
                  selectAllCustomersId(
                    filteredCustomers.map(item => item.id).filter(item => item)
                  )
                }
              >
                Select all
              </ColorButton>

              <ColorButton
                className="ml3"
                borderClass="b-op-brand"
                onClick={clearCustomersId}
              >
                Deselect all
              </ColorButton>
            </div>

            <CustomerCheckbox
              setCustomer={setCustomer}
              removeCustomer={removeCustomer}
              customerIds={customerIds}
            />
          </div>

          <div className="w-100 h3 bg-near-white flex flex-none items-center justify-end ph3">
            <ColorButton
              colorClass="gray"
              borderClass="b--gray"
              onClick={cancel}
            >
              Cancel
            </ColorButton>
            <ColorButton
              disabled={!customerIds.length || isSaving}
              className="ml3"
              colorClass="op-brand"
              borderClass="b-op-brand"
              onClick={save}
            >
              Copy this poll
            </ColorButton>
          </div>
        </div>
      </PageOverlay>
    )
  }
}

const mapStateToProps = state => ({
  isSaving: isSaving(state),
  errors: getErrors(state),
  isOngoing: isOngoing(state),
  customerIds: getCustomerIds(state),
  filteredCustomers: selectFilteredCustomers(state),
  activeFilter: state.customersStore.filter,
})

const mapDispatchToProps = {
  save: startSave,
  cancel: cancelCopyPoll,
  setCustomer,
  removeCustomer,
  filterCustomers,
  clearCustomersId,
  selectAllCustomersId,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CopyModal)



// WEBPACK FOOTER //
// ./src/components/PollCopy/PollCopy.js